import React, { useRef } from "react";
import styles from "./antdTab.module.css";
import { Carousel, Col, Row, Tabs } from "antd";
import TextComponent from "../textComponent/TextComponent";
import { useState } from "react";
import Box from "../box/Box";
import SubmitButton from "../submitButton/SubmitButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";

const AntdTab = ({ items, centered, titleClass }) => {
  const [ActiveTab, setActiveTab] = useState("1");
  return (
    <Tabs
      defaultActiveKey="1"
      items={items}
      animated
      activeKey={ActiveTab}
      // onTabClick={details}
      renderTabBar={(props) => {
        return (
          <>
            <Row
              className={`${styles.tabsCont} ${centered && styles.centered} ${
                styles.gapClass
              }`}
            >
              {props.panes.map((tab) => (
                <Col
                  key={tab.props.tabKey}
                  className={styles.tabCol}
                  onClick={() => {
                    setActiveTab(tab.props.tabKey);
                  }}
                >
                  <Row className={styles.tabRow}>
                    <TextComponent
                      text={tab.props.tab}
                      textClass={`${styles.tabText} ${titleClass} ${
                        props.activeKey == tab.props.tabKey && styles.activeTab
                      }`}
                    />
                    {props.activeKey == tab.props.tabKey && (
                      <Row className={styles.activeTabBar} />
                    )}
                  </Row>
                </Col>
              ))}
            </Row>
          </>
        );
      }}
    />
  );
};

export const BoxTabs = ({
  items,
  changeHeaderOnTab,
  showRightBtn,
  activeKey,
  destroyOnBlur,
}) => {
  const [ActiveTab, setActiveTab] = useState(activeKey ? activeKey : "1");
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrolEnd, setscrolEnd] = useState(false); // For detecting end of scrolling
  const { state } = useLocation();
  const navigate = useNavigate();
  const scrl = useRef();

  useEffect(() => {
    if (!activeKey) {
      checkHeader();
    } else {
      document.getElementById(activeKey).scrollIntoView();
    }
  }, []);

  const checkHeader = () => {
    if (changeHeaderOnTab) {
      navigate(".", {
        state: {
          ...state,
          headrTitle: items[0].headerTitle
            ? items[0].headerTitle
            : items[0].label,
          activeKey: ActiveTab,
        },
        replace: true,
      });
    }
  };

  const slide = (shift) => {
    scrl.current.scrollBy({ left: shift, behavior: "smooth" });
    setscrollX(scrollX + shift); // Updates the latest scrolled postion

    //For checking if the scroll has ended
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const scrollCheck = () => {
    setscrollX(scrl.current.scrollLeft);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  useEffect(() => {
    //Check width of the scollings
    if (
      scrl.current &&
      scrl?.current?.scrollWidth === scrl?.current?.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
    return () => {};
  }, [scrl?.current?.scrollWidth, scrl?.current?.offsetWidth]);

  return (
    <Tabs
      defaultActiveKey="1"
      items={items}
      className={styles.boxTabs}
      activeKey={ActiveTab}
      destroyInactiveTabPane={destroyOnBlur}
      renderTabBar={(props) => {
        return (
          <>
            <Row
              className={styles.mainRow}
              style={{ justifyContent: "space-between" }}
              ref={scrl}
              onScroll={scrollCheck}
            >
              <Col className={styles.tabsClass}>
                <Row className={`${styles.tabsCont} ${styles.boxTab}`}>
                  {/* <Carousel dots={styles.dots}> */}
                  {props.panes.map((tab) => (
                    <Col
                      id={tab.props.tabKey}
                      key={tab.props.tabKey}
                      className={styles.tabCol}
                      onClick={() => {
                        if (changeHeaderOnTab && tab.props.children) {
                          console.log(
                            "===================================================",
                            state
                          );
                          navigate(".", {
                            state: {
                              ...state,
                              headrTitle: tab.props.headerTitle
                                ? tab.props.headerTitle
                                : tab.props.tab,
                              activeKey: tab.props.tabKey,
                            },
                            replace: true,
                          });
                        } else if (!tab.props.children) {
                          tab.props.onClick();
                        }
                        setActiveTab(tab.props.tabKey);
                      }}
                    >
                      <Row className={styles.tabRow}>
                        <Box
                          boxClass={`${styles.boxButton} ${
                            props.activeKey == tab.props.tabKey
                              ? styles.active
                              : styles.inActive
                          }`}
                        >
                          <TextComponent
                            textClass={`${
                              props.activeKey == tab.props.tabKey
                                ? styles.active
                                : styles.inActive
                            }`}
                          >
                            {tab.props.tab}
                          </TextComponent>
                        </Box>
                      </Row>
                    </Col>
                  ))}
                  {/* </Carousel> */}
                </Row>
              </Col>
              {scrollX !== 0 && (
                <div
                  className={`${styles.scrollBtnOverlay} ${styles.leftScroll}`}
                >
                  <div
                    className={`${styles.scrollBtn}`}
                    onClick={() => slide(-220)}
                  >
                    <BiChevronLeft />
                  </div>
                </div>
              )}
              {!scrolEnd && (
                <div
                  className={`${styles.scrollBtnOverlay} ${styles.rightScroll}`}
                >
                  <div
                    className={`${styles.scrollBtn} `}
                    onClick={() => slide(+220)}
                  >
                    <BiChevronRight />
                  </div>
                </div>
              )}
              {showRightBtn && (
                <Col
                  className={styles.btnClass}
                  onClick={() => {
                    navigate("/templates/Addtemplate");
                  }}
                >
                  <SubmitButton title="Upload Template" />
                </Col>
              )}
            </Row>
          </>
        );
      }}
    />
  );
};

export default AntdTab;
